import { gql, TypedDocumentNode } from "@apollo/client";

import { AwsIntegration } from "types/generated";

export type AwsIntegrationView = Pick<
  AwsIntegration,
  | "id"
  | "name"
  | "roleArn"
  | "durationSeconds"
  | "generateCredentialsInWorker"
  | "autoattachEnabled"
  | "externalId"
  | "region"
  | "labels"
  | "hasAttachedStacks"
  | "hasAttachedScans"
  | "tagAssumeRole"
> & {
  spaceDetails: Pick<AwsIntegration["spaceDetails"], "id" | "name" | "accessLevel">;
};

type SearchAwsIntegrationsData = {
  awsIntegrations: AwsIntegrationView[];
};

export const SEARCH_AWS_INTEGRATIONS: TypedDocumentNode<SearchAwsIntegrationsData> = gql`
  query SearchAWSIntegrations {
    awsIntegrations(includeLegacy: false) {
      id
      name
      roleArn
      durationSeconds
      generateCredentialsInWorker
      autoattachEnabled
      externalId
      region
      labels
      tagAssumeRole
      spaceDetails {
        id
        name
        accessLevel
      }
      hasAttachedStacks
      hasAttachedScans
    }
  }
`;
